import axios, { AxiosError, AxiosRequestConfig } from 'axios'

import { apiUrl, requestTimeout } from '@/data/appConfig'
import { getAndSaveConfigToken } from '@/sdk/oauth'
import store from '@/store'

const getSavedConfigToken = (): string => store.getters['auth/configToken']()

const requestInstance = axios.create({
  baseURL: apiUrl,
  timeout: requestTimeout,
})

requestInstance.interceptors.request.use(
  async requestConfig => {
    if (!getSavedConfigToken()) {
      await getAndSaveConfigToken()
    }

    requestConfig.headers.Authorization = `Bearer ${getSavedConfigToken()}`

    return Promise.resolve(requestConfig)
  },
  error => Promise.reject(error),
)

requestInstance.interceptors.response.use(
  axiosResponse => axiosResponse,
  async (error: AxiosError<any>) => {
    const originalRequest: AxiosRequestConfig = error.config

    if (error.response?.status === 401 || error.message === 'Network Error') {
      await getAndSaveConfigToken()

      const request: AxiosRequestConfig = {
        ...originalRequest,
        headers: {
          ...(originalRequest.headers || {}),
          Authorization: `Bearer ${getSavedConfigToken()}`,
        },
        url: (originalRequest.url || '').split(apiUrl).join(''),
      }

      return axios(request)
    }
  },
)

export default requestInstance
